import { GlobalStoreCtx } from '@/stores/GlobalStore';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';

import styles from './StyleComponent.module.scss';

export interface IStyleComponentProps {
  style?: React.CSSProperties;
  className?: string;
  /** 스타일과 클래스를 `appDevice`가 참이여도 적용. */
  ignoreAppDevice?: boolean;
  'data-test'?: string;
}

const StyleComponent: React.FC<IStyleComponentProps> = ({
  style: propStyle,
  className,
  ignoreAppDevice,
  children,
  'data-test': testID,
}) => {
  const globalStore = useContext(GlobalStoreCtx);

  const appDevice = globalStore.AppDevice;
  const withSmartBanner = globalStore.ShowSmartBanner;
  const applyStyle = ignoreAppDevice || !appDevice;

  return (
    <div
      className={clsx(styles.container, applyStyle && className)}
      style={applyStyle ? propStyle : undefined}
      data-test={testID}
    >
      {withSmartBanner && <div className={styles.smartBannerWrap} />}
      {children}
    </div>
  );
};

export default observer(StyleComponent);
